import "./style.scss";
import "./style-mob.scss";
import { FC } from "react";
import { Link } from "react-router-dom";

interface IReadMoreBtn {
  text: string;
  link: string;
  reverse?: boolean;
  className?: string;
}

const ReadMoreBtn: FC<IReadMoreBtn> = ({ text, link, reverse = false, className = "" }) => {
  const classes = `read-more-btn${reverse ? " reverse" : ""} ${className}`.trim();

  return (
    <Link to={link} className={classes}>
      {text}
    </Link>
  );
};
export default ReadMoreBtn;
